var module = angular.module('octopusApp.configuration');

module.controller('DiagnosticsIndexController', function($scope, busy, octopusRepository, pollLoop, octoDialog, $state, $location) {
  var isLoading = $scope.isLoading = busy.create();
  var isChecking = $scope.isChecking = busy.create();
  var isCollecting = $scope.isCollecting = busy.create();
  var ssr = octopusRepository.ServerStatus;

  $scope.diagnosticTab = 'serverLogs';
  $scope.showSystemReportWarning = false;

  isLoading.promise(ssr.getExtensionStats().then(function(extensionStats) {
    $scope.extensions = extensionStats;
  }));

  var refresh = function() {
    return isLoading.promise(ssr.getServerStatus().then(function(status) {
      return isLoading.promise(ssr.getLogs(status).then(function (logs) {
        return isLoading.promise(ssr.getSystemInfo(status).then(function (info) {
          $scope.status = status;
          $scope.info = info;
          $scope.logs = logs.slice(-5);
          $scope.more = logs.length - 5;
          $scope.systemReportLink = octopusRepository.resolve(status.Links["SystemReport"]);
        }));
      }));
    }));
  };

  var loop = pollLoop.create($scope, refresh);
  loop.startImmediately();

  $scope.gcCollect = function() {
    ssr.gcCollect($scope.status).then(function (info) {
      $state.reload();
    });
  };

  $scope.deepCount = function(activities) {
    if (!activities) {
      return 0;
    }
    var count = activities.length;
    _.each(activities, function(activity) {
      count += $scope.deepCount(activity.SupervisedActivities);
    });
    return count;
  };

  $scope.checkSystemIntegrity = function()
  {
    isChecking.promise(octopusRepository.Tasks.create({
      Name: 'SystemIntegrityCheck',
      Description: 'Check System Integrity'
    }).then(function (newTask) {
      $location.path("/tasks/" + newTask.Id);
    }));
  };
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/diagnostics/controllers/diagnostics_index_controller.js
// module id = 2339820309204266
// module chunks = 1